/** Stroke icons from the design; every status pairs a shape with its color. */
export const PATHS = {
  up: "M21 12a9 9 0 1 1-18 0a9 9 0 1 1 18 0Z M8 12.4l2.8 2.8L16.2 9.6",
  degraded: "M12 3.2L22 20.5H2Z M12 9.6v4.8 M12 17.4v.1",
  down: "M8.3 2.8h7.4l5.5 5.5v7.4l-5.5 5.5H8.3l-5.5-5.5V8.3Z M9 9l6 6 M15 9l-6 6",
  unknown:
    "M12 2.5l9.5 9.5L12 21.5L2.5 12Z M9.9 9.8a2.2 2.2 0 1 1 3 2c-.6.3-.9.7-.9 1.4 M12 16.1v.1",
  logo: "M12 9a3 3 0 1 0 0 6a3 3 0 1 0 0-6Z M12 2.5v4 M12 17.5v4 M2.5 12h4 M17.5 12h4",
  sun: "M12 8a4 4 0 1 0 0 8a4 4 0 1 0 0-8Z M12 2.5v2 M12 19.5v2 M4.6 4.6l1.4 1.4 M18 18l1.4 1.4 M2.5 12h2 M19.5 12h2 M4.6 19.4L6 18 M18 6l1.4-1.4",
  moon: "M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z",
  expand: "M4 9V4h5 M20 9V4h-5 M4 15v5h5 M20 15v5h-5",
  shrink: "M9 4v5H4 M15 4v5h5 M9 20v-5H4 M15 20v-5h5",
  density: "M4 5h16 M4 9.5h16 M4 14h16 M4 18.5h16",
  chevron: "M6 9l6 6l6-6",
  signout: "M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3 M10 8l-4 4l4 4 M6 12h10",
  arrow: "M5 12h14 M13 6l6 6l-6 6",
  lock: "M7 11V8a5 5 0 0 1 10 0v3 M5 11h14v10H5Z M12 15v2.5",
  clock: "M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18Z M12 7.5V12l3 2",
  bell: "M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15Z M10 20.5a2 2 0 0 0 4 0",
  close: "M6 6l12 12 M18 6L6 18",
  search: "M11 4a7 7 0 1 0 0 14a7 7 0 1 0 0-14Z M16.2 16.2L21 21",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  label,
  className,
}: {
  name: IconName;
  label?: string;
  className?: string;
}) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: labelled icons get a <title>; the rest are aria-hidden decoration
    <svg
      className={className ? `ico ${className}` : "ico"}
      viewBox="0 0 24 24"
      {...(label ? { role: "img", "aria-label": label } : { "aria-hidden": true })}
    >
      {label && <title>{label}</title>}
      <path d={PATHS[name]} />
    </svg>
  );
}
